export const QandA = [{
    id: '1',
    q: 'I can\'t scan the barcode. / Do I have to use the barcode?',
    a: 'If the barcode does not scan, please type in the serial number found at the bottom of your PVS Information Card into the Barcode Number field.'
},
{
    id: '2',
    q: 'The application does not accept the barcode number I have entered',
    a: 'Please contact the PVS team at 800-843-0912 for assistance.'
},
{
    id: '3',
    q: 'I lost my label. / I don\'t have a serial number.',
    a: 'Please contact the PVS team at 800-843-0912 for assistance.'
},
{
    id: '4',
    q: 'How do I reset my password?',
    a: 'Select the "Forgot your password?" button on the login page. An email with a verification code and reset instructions will be sent to you. If you do not receive an email, please call our PVS team for assistance at 800-843 -0912'
},
{
    id: '5',
    q: 'Is there an option to use PVS without the application/receive my report via email?',
    a: 'To get the most out of your PVS kits, we recommend using the application, as this is the easiest way for you to submit a kit and view past reports. However, reports will still be emailed to the primary contact once the kit has been processed by Streck.'
}
];